import React from 'react';

import EnhancedDisplay, { IEnhancedDisplayProps } from './EnhancedDisplay';

const EnhancedDisplayWrapper: React.FC<IEnhancedDisplayProps> = ({
  currencySymbol,
  ...props
}) => {
  return <EnhancedDisplay {...props} currencySymbol={currencySymbol} />;
};

export default EnhancedDisplayWrapper;
